import { Component, OnInit } from "@angular/core";
import { BigmlFieldDTO } from "@DTOS";

@Component({
    templateUrl: "./tipo-ensembleboost-configuracion-modal.component.html",
    styleUrls: ["./tipo-ensembleboost-configuracion-modal.component.scss"]
})
export class TipoEnsembleboostConfiguracionModalComponent implements OnInit {
    public campo: BigmlFieldDTO = new BigmlFieldDTO();

    constructor() { }

    ngOnInit(): void {
    }

}
